<template>
  <div style="padding: 20px 12px 0 12px;" v-if="favMenus && favMenus.length > 0">
    <v-carousel
      height="180"
      class="elevation-20 rounded-lg"
      cycle
      style="border-radius: 5px;"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
    >
      <!-- Iteración sobre la lista de elementos -->
      <v-carousel-item
        v-for="card of favMenus"
        :key="card.ID"
      >
        <!-- Tarjeta centrada dentro del slide -->
        <v-sheet
          height="100%"
          display="flex"
          align="center"
          justify="center"
        >
        <card-button
          :ID="card.ID"
          :card="card"
          :image="card.Image"
          :bgColor="card.MenuBGColor"
          :textColor="card.MenuTextColor"
          :onSelectMenu="handleTouch"
          :fontSize="card.FontSize"
          :font="card.Font"
          :text="getTranslation(card.Name, locale, card.TextFormat)" 
          :isFav="true"
        />
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import CardButton from './CardButton'
export default {
  components: {
    CardButton,
  },
  props: {
    domain: {
      type: String,
      required: true,
    },
    onSelectMenu: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    favMenus: [],
    activeMenu: 1,
  }),
  computed: {
    ...mapState('app',['locale', 'menus']),
  },
  watch: {
    domain () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    getTranslation (v, locale, textFormat, split) {
      let aux = utils.getTranslation(v, locale)
      if (split && aux.length > 10) {
        aux = aux.substring(0, 10) + '...'
      }
      return textFormat === 1 ? aux.toUpperCase() : textFormat === 2 ? aux.toLowerCase() : aux
    },
    async handleGetData () {
      try {
        if (!this.domain) {
          this.favMenus = []
          return
        }

        api.getAll(`enterprises`, false, null, null, null, `${this.domain}/favorites`)
          .then(response => {
            if (!response) return
            this.favMenus = response
          })
      } catch (error) {
        console.log(error)
      }
    },
    handleTouch (v) {
      if (this.menus.filter(x => x.ID===v.ID).length > 0) {
        this.onSelectMenu(this.menus.filter(x => x.ID===v.ID).shift())
        //const aux = this.menus.filter(x => x.ID===v.ID).shift()
        //v.Menus = aux ? aux.Menus : null
      } else {
        this.onSelectMenu(v)
      }
    },
  },
}
</script>
<style scoped>
.v-carousel__controls {
  bottom: -6px;
}
/* Transición suave al cambiar de tamaño u opacidad */
.transition-swing {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* La tarjeta activa se ve al 100% */
.tarjeta-activa {
  transform: scale(1.05);
  opacity: 1;
}

/* Las tarjetas de los lados se ven ligeramente más pequeñas y opacas */
.tarjeta-lateral {
  transform: scale(0.95);
  opacity: 0.6;
}
</style>

